import * as React from 'react';
import { Translate } from "react-localize-redux";
import Routes from 'src/core/Routes';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { Row, Col, Form, Button, Input } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { NameOf } from "src/utils/NameOf";
import { AntForm, AntFormItems, AntFormSimple, AntFormRules } from "src/utils/formUtil/Form";
import ObjectUtil from "src/utils/ObjectUtil";

export class UpdateThingDTO {
    username: string;
    password: string;
    confirmPassword: string;
    age: number;
    isActive: boolean;
}

interface FormTestSimpleFormProps {
    values: UpdateThingDTO;
    onSubmit: (values: UpdateThingDTO) => void;
}

interface FormTestSimpleFormState {
    formData: UpdateThingDTO;
}

class FormTestSimpleForm extends React.Component<FormTestSimpleFormProps, FormTestSimpleFormState> {
    constructor(props: FormTestSimpleFormProps) {
        super(props);
        bindAllOfThis(this, FormTestSimpleForm.prototype);

        this.state = {
            formData: { } as UpdateThingDTO,
        };
    }

    onSubmit(values: any) {
        this.props.onSubmit(values);
    }

    onChange(values: UpdateThingDTO) {
        console.warn("Receiving onChange"); // JB - Remove this console.warn
        this.setState({
            formData: ObjectUtil.DeepMergeObjects(this.state.formData, values),
        });
    }

    render() {
        let formData = this.state.formData || {} as UpdateThingDTO;

        return <Row>
            <Col span={12}>
                <AntFormSimple onChange={x => this.onChange(x)} onSubmit={x => this.onSubmit(x)}>
                    <AntFormItems.Input
                        uniqueId={NameOf<UpdateThingDTO>("username")}
                        label={"Username"}
                        initialValue={this.props.values.username}
                    />
                    <AntFormItems.Input
                        uniqueId={NameOf<UpdateThingDTO>("password")}
                        label={"Password"}
                        type={"password"}
                        rules={[
                            AntFormRules.Required("Required!!"),
                            AntFormRules.Min(3, "Must have a length of 3"),
                            AntFormRules.Max(7, "Must have a length less than 7"),
                        ]}
                    />
                    <AntFormItems.Input
                        uniqueId={NameOf<UpdateThingDTO>("confirmPassword")}
                        label={"Password Again"}
                        type={"password"}
                        rules={[AntFormRules.Exact(formData.password, "Must match Real Password")]}
                    />
                    
                    <AntFormItems.Input
                        uniqueId={NameOf<UpdateThingDTO>("age")}
                        label={"Password Again"}
                        initialValue={this.props.values.age}
                        rules={[AntFormRules.Number("Must be a Number")]}
                    />

                    <AntFormItems.SubmitButton>Submit!</AntFormItems.SubmitButton>
                </AntFormSimple>
            </Col>
        </Row>;
    }
}

export default FormTestSimpleForm;



// WEBPACK FOOTER //
// ./src/pages/examples/FormTestSimpleForm.tsx